import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useQueryHook } from '../../shared/hooks/useQueryHook';
import {
    GetAllCountries, GetAllDeliveryTerms, GetAllPackingTypes,
    GetAllPaymentTerms, GetAllPorts, GetAllProductNames,
    GetAllShippingModes, GetAllBusinessPartners, CreateNewPFI,
    GetCompanyAllBanks, UpdatePFI, GetIncrementedPfiNumber
} from '../../shared/common/graphqlQuery';
import { transformEachApiDataKeyValue } from '../../shared/hooks/transfromApiData';
import { companyData } from '../../core/auth';
import { dateFormat, routeConfig } from '../../shared/common/constant';
import './addEditProforma.scss';
import { Select, Input, DatePicker, Button, Form, Space, InputNumber, Checkbox, message, Col, Row } from 'antd';
import { DeleteTwoTone, FolderAddTwoTone, LoadingOutlined } from '@ant-design/icons';
import { convertNumTOWords } from '../../shared/hooks/wordNumb';
import moment from 'moment';
import { useMutationHook } from '../../shared/hooks/useMutationHook';
import { api, useStore } from '../../shared/hooks/stateStore';
import cloneDeep from 'lodash/cloneDeep';
import { hideSuggestions, roundOffDigits, validateNameMessages } from '../../shared/hooks/utils';

const renderOption = (eachOption: any) => {
    return (
        <Select.Option value={eachOption.key ? eachOption.key : eachOption.value}
            key={eachOption.key ? eachOption.key : eachOption.value} className="dropdown__ellipsis">
            {eachOption.value}
        </Select.Option>
    )
}

const renderOptionPort = (eachOption: any) => {
    return (
        <Select.Option value={eachOption['_id'] ? eachOption['_id'] : eachOption.port}
            key={eachOption['_id'] ? eachOption['_id'] : eachOption.port} className="dropdown__ellipsis">
            {eachOption.port}, {eachOption.country}
        </Select.Option>
    )
}
let tableRowdataDelivery = [];
let tableRowdataPackingTypes = [];
let tableRowdataPaymentTerms = [];
let tableRowdataShippingModes = [];
let tableRowdataProducthsCode = [];
let tableRowdataProductName = [];
let tableRowdataConsignee = [];
let tableRowdataCountries = [];
let tableRowdataPorts = [];
let tableRowdataCurrency = [];
let tableRowDataCompanyBank = [];
let pfiNumber;
let pfiDetailDatas = []
const consigneeConst: any = {
    name: '',
    address: '',
    country: '',
    email: '',
    phoneNumber: ''
};
const bankDetailConst: any = {
    acNumber: '',
    accountName: '',
    address: '',
    bankName: '',
    swiftCode: ''
}
let proformaData;
const AddEditProforma = () => {
    const companyId = companyData().getCompanyData();
    const { proformaId } = useParams<any>();
    const [selectedCurrency, setSelectedCurrency] = useState<string>('');
    const [selectedDeliveryTerms, setSelectedDeliveryTerms] = useState<string>('');
    const [buyerNameConst, setBuyerName] = useState<string>('');
    const [consigneeDetails, setConsigneeDetails] = useState(consigneeConst);
    const [bankDetails, setBankDetails] = useState(bankDetailConst);
    const [buyerSameCheckBox, setBuyerSameCheckBox] = useState<boolean>(false);

    const [minTotalPriceError, setMinTotalPriceError] = useState<boolean>(false);
    const [currencyData, setcurrencyData] = useState<any>([]);

    useEffect(() => {
        fetch('https://openexchangerates.org/api/currencies.json')
            .then(response => response.json())
            .then(data => Object.entries(data).map(([key, value], index) => {
                tableRowdataCurrency.push({ key, value });
                if (index === (Object.keys(data).length - 1)) {
                    setcurrencyData(tableRowdataCurrency);
                }
            }));
        if (proformaId) {
            proformaData = cloneDeep(useStore.getState().pfiData);

            if (!proformaData) {
                history.push(routeConfig.proformaList.path);
            } else {

                setSelectedDeliveryTerms(proformaData.deliveryTerms.deliveryTerm);
                proformaData.date = moment(proformaData.date, dateFormat);
                proformaData.customerPoDate = proformaData.customerPoDate ? moment(proformaData.customerPoDate, dateFormat) : '';

                setConsigneeDetails({
                    name: proformaData.businessPartner.name,
                    address: proformaData.businessPartner.address,
                    country: proformaData.businessPartner.country,
                    email: proformaData.businessPartner.email,
                    phoneNumber: proformaData.businessPartner.phoneNumber
                });
                proformaData.businessPartner = proformaData.businessPartner['_id'];

                proformaData.paymentTerms = proformaData.paymentTerms['_id'];
                proformaData.deliveryTerms = proformaData.deliveryTerms['_id'];
                // proformaData.deliverySchedule = moment(proformaData.deliverySchedule, dateFormat);
                // proformaData.validityOfPI = moment(proformaData.validityOfPI, dateFormat);

                proformaData.shippingMode = proformaData.shippingMode['_id'];
                proformaData.portOfLoading = proformaData.portOfLoading['_id'];
                proformaData.portOfDestination = proformaData.portOfDestination['_id'];
                proformaData.countryOfOrigin = proformaData.countryOfOrigin['_id'];
                proformaData.finalDestination = proformaData.finalDestination ? proformaData.finalDestination['_id'] : null;
                proformaData.countryOfDestination = proformaData.countryOfDestination['_id'];

                setBankDetails({
                    acNumber: proformaData.bankDetails.acNumber,
                    accountName: proformaData.bankDetails.accountName,
                    address: proformaData.bankDetails.address,
                    bankName: proformaData.bankDetails.bankName,
                    swiftCode: proformaData.bankDetails.swiftCode
                })
                proformaData.bankDetails = proformaData.bankDetails['_id'];

                proformaData.pfiItemDetails.map(eachPfiItemData => {
                    eachPfiItemData.packingTypes = eachPfiItemData.packingTypes['_id']
                    eachPfiItemData.descriptionOfGoods = eachPfiItemData.descriptionOfGoods['_id']
                    eachPfiItemData.hsCode = eachPfiItemData.descriptionOfGoods;
                    delete eachPfiItemData.__typename;
                    return eachPfiItemData;
                });
                setBuyerName(proformaData.buyer.name);
                pfiDetailDatas = proformaData.pfiItemDetails;
                setSelectedCurrency(proformaData.currency);
                proformaData.amountInWords = convertNumWord(proformaData.totalAmount, proformaData.currency);
                form.setFieldsValue(proformaData);
            }
        } else {
            proformaData = {
                pfiItemDetails: [{}]
            };
            form.setFieldsValue(proformaData);
        }
        const unsub = api.subscribe(state => {
            if (state.saveInvoice) {
                useStore.setState({ saveInvoice: 0, pfiData: null });
                validate();
            }
        })
        hideSuggestions();
        return () => {
            unsub();
        }
    }, []);

    const [form] = Form.useForm();
    const history = useHistory();
    const redirectBack = () => {
        history.push(routeConfig.proformaList.path);
    }

    const onSubmittedPfiDetails = () => {
        redirectBack();
    }
    const onError = ({ graphQLErrors, networkError }) => {
        console.log(graphQLErrors);
        console.log(networkError)
        if (graphQLErrors[0].message === 'ACTION_NOT_ALLOWED') {
            message.error('Duplicate Invoice No. Please change the Invoice No.')
        } else {
            message.error('Something went wrong. Please try again.');
        }
    }

    const ConsigneeQuery = useQueryHook(GetAllBusinessPartners, { companyId: companyId });
    const allBusinessPartnerData = ConsigneeQuery.data?.getAllBusinessPartners;

    useEffect(() => {
        useStore.setState({ consigneeData: ConsigneeQuery.data?.getAllBusinessPartners });
    }, [ConsigneeQuery.data?.getAllBusinessPartners]);

    const PfiDetailsMutation = useMutationHook(CreateNewPFI, onSubmittedPfiDetails, onError);
    const PfiDetailsUpdateMutation = useMutationHook(UpdatePFI, onSubmittedPfiDetails, onError);
    const CountriesQuery = useQueryHook(GetAllCountries, { companyId: companyId });
    const DeliveryTermsQuery = useQueryHook(GetAllDeliveryTerms, { companyId: companyId });
    const PackingTypesQuery = useQueryHook(GetAllPackingTypes, { companyId: companyId });
    const PaymentTermsQuery = useQueryHook(GetAllPaymentTerms, { companyId: companyId });
    const PortsQuery = useQueryHook(GetAllPorts, { companyId: companyId });
    const ProductNamesQuery = useQueryHook(GetAllProductNames, { companyId: companyId });
    const ShippingModesQuery = useQueryHook(GetAllShippingModes, { companyId: companyId });
    const CompanyBankQuery = useQueryHook(GetCompanyAllBanks, { companyId: companyId });
    
    
    tableRowdataDelivery = transformEachApiDataKeyValue(DeliveryTermsQuery.data?.getAllDeliveryTerms, 'deliveryTerm');
    tableRowdataCountries = transformEachApiDataKeyValue(CountriesQuery.data?.getAllCountries, 'country');
    tableRowdataPackingTypes = transformEachApiDataKeyValue(PackingTypesQuery.data?.getAllPackingTypes, 'packingType');
    tableRowdataPorts = transformEachApiDataKeyValue(PortsQuery.data?.getAllPorts, 'port');
    tableRowdataPaymentTerms = transformEachApiDataKeyValue(PaymentTermsQuery.data?.getAllPaymentTerms, 'paymentTerm');
    tableRowdataShippingModes = transformEachApiDataKeyValue(ShippingModesQuery.data?.getAllShippingModes, 'shippingMode');
    tableRowdataProducthsCode = transformEachApiDataKeyValue(ProductNamesQuery.data?.getAllProductNames, 'hsCode')
    tableRowdataProductName = transformEachApiDataKeyValue(ProductNamesQuery.data?.getAllProductNames, 'productName')
    tableRowdataConsignee = transformEachApiDataKeyValue(ConsigneeQuery.data?.getAllBusinessPartners, 'name');
    tableRowDataCompanyBank = transformEachApiDataKeyValue(CompanyBankQuery.data?.getCompanyAllBanks, 'accountName');

    const constPfiNumber = useQueryHook(GetIncrementedPfiNumber, { companyId: companyId });
    if (!proformaId && constPfiNumber.data?.getIncrementedPfiNumber) {
        proformaData = {
            invoiceNumber: constPfiNumber.data?.getIncrementedPfiNumber
        };
        form.setFieldsValue(proformaData);
    }

    const onChangeCurrency = () => {
        setSelectedCurrency(form.getFieldValue('currency'));

        form.setFieldsValue({
            amountInWords: convertNumWord(form.getFieldValue('totalAmount') || 0, form.getFieldValue('currency'))
        })
    }

    const onChangeDeliveryTerms = () => {
        const deliveryTermsIndex = tableRowdataDelivery.findIndex((eachRowData) => eachRowData.key === form.getFieldValue('deliveryTerms'));
        setSelectedDeliveryTerms(tableRowdataDelivery[deliveryTermsIndex].value);
    }
    const totalFobPriceFunc = () => {
        const breakUpAmounts = form.getFieldValue('breakUpAmount');
        const totalFobPrice = roundOffDigits((breakUpAmounts.cfbPrice || 0) - (breakUpAmounts.lessFreight || 0) - (breakUpAmounts.lessInsurance || 0));
        form.setFieldsValue({
            breakUpAmount: {
                totalFobPrice: totalFobPrice
            }
        });
        if (totalFobPrice < 0) {
            setMinTotalPriceError(true);
        } else {
            setMinTotalPriceError(false);
        }
    }

    const onNoPackageChange = (index) => {
        let pfiItemDetails = form.getFieldValue('pfiItemDetails');

        let totalQuantity = 0;
        pfiItemDetails.map(eachListValue => {
            totalQuantity += +eachListValue?.quantity || 0;
        })

        if(index !== -1) {
            pfiItemDetails = countEachPfiItemsAmount(pfiItemDetails, index);
        }

        const totalAmount = countTotalAmount(pfiItemDetails);
        const amountInWords = convertNumWord(totalAmount, selectedCurrency);
        form.setFieldsValue({
            totalQuantity: roundOffDigits(totalQuantity),
            pfiItemDetail: pfiItemDetails,
            totalAmount: totalAmount,
            amountInWords: amountInWords
        })
    }

    const onPriceChange = (index) => {
        let pfiItemDetails = form.getFieldValue('pfiItemDetails');
        pfiItemDetails = countEachPfiItemsAmount(pfiItemDetails, index);
        const totalAmount = countTotalAmount(pfiItemDetails);
        const amountInWords = convertNumWord(totalAmount, selectedCurrency);
        form.setFieldsValue({
            pfiItemDetail: pfiItemDetails,
            totalAmount: totalAmount,
            amountInWords: amountInWords
        })
    }

    const countTotalAmount = (pfiItemDetails) => {
        let totalAmount = 0;
        pfiItemDetails.map(eachListValue => {
            totalAmount += +eachListValue?.amount || 0;
        })
        const totalAmountConst = roundOffDigits(totalAmount);
        form.setFieldsValue({
            breakUpAmount: {
                cfbPrice: totalAmountConst
            }
        });
        totalFobPriceFunc();
        return totalAmountConst;
    }
    const convertNumWord = (totalAmount, currentCurrency) => {
        return convertNumTOWords(totalAmount, currentCurrency);
    }
    const countEachPfiItemsAmount = (pfiItemDetails, index) => {
        pfiItemDetails[index].amount = roundOffDigits((+pfiItemDetails[index]?.quantity || 0) * (+pfiItemDetails[index].rate || 0))
        return pfiItemDetails;
    }

    const onChangeConsignee = () => {
        const businessPartnerId = form.getFieldValue('businessPartner');
        const indexConsignee = allBusinessPartnerData.findIndex(eachConsigneeData => eachConsigneeData['_id'] === businessPartnerId);
        const currentConsigneeDetail = allBusinessPartnerData[indexConsignee];
        setConsigneeDetails({
            name: currentConsigneeDetail.name,
            address: currentConsigneeDetail.address,
            country: currentConsigneeDetail.country,
            email: currentConsigneeDetail.email,
            phoneNumber: currentConsigneeDetail.phoneNumber
        });
        if (buyerSameCheckBox) {
            form.setFieldsValue({
                buyer: {
                    name: currentConsigneeDetail.name,
                    address: currentConsigneeDetail.address
                }
            });
            buyerName();
        }
    }

    const onChangeBankDetails = () => {
        const bankDetailsId = form.getFieldValue('bankDetails');
        const indexBankDetails = CompanyBankQuery.data?.getCompanyAllBanks.findIndex(eachConsigneeData => eachConsigneeData['_id'] === bankDetailsId);
        const currentBankDetail = CompanyBankQuery.data?.getCompanyAllBanks[indexBankDetails];
        setBankDetails({
            acNumber: currentBankDetail.acNumber,
            accountName: currentBankDetail.accountName,
            address: currentBankDetail.address,
            bankName: currentBankDetail.bankName,
            swiftCode: currentBankDetail.swiftCode
        })
    }
    const onChangeHsCode = (index) => {
        let pfiDetailData = form.getFieldValue('pfiItemDetails');
        pfiDetailData[index].descriptionOfGoods = pfiDetailData[index].hsCode;

        const productNameIndex = ProductNamesQuery.data?.getAllProductNames.findIndex((eachProducts) => eachProducts['_id'] === pfiDetailData[index].hsCode);
        pfiDetailData[index].unitType = ProductNamesQuery.data?.getAllProductNames[productNameIndex].unitType;
        form.setFieldsValue({
            pfiItemDetails: pfiDetailData
        });
    }

    const onChangeProductName = (index) => {
        let pfiDetailData = form.getFieldValue('pfiItemDetails');
        pfiDetailData[index].hsCode = pfiDetailData[index].descriptionOfGoods;

        const productNameIndex = ProductNamesQuery.data?.getAllProductNames.findIndex((eachProducts) => eachProducts['_id'] === pfiDetailData[index].descriptionOfGoods);
        pfiDetailData[index].unitType = ProductNamesQuery.data?.getAllProductNames[productNameIndex].unitType;
        form.setFieldsValue({
            pfiItemDetails: pfiDetailData
        })
    }

    const onFinish = (values: any) => {
        if (values && !minTotalPriceError) {
            const pfiData = values;
            pfiData.date = moment(pfiData.date).format(dateFormat).toString();
            pfiData.customerPoDate = pfiData.customerPoDate ? moment(pfiData.customerPoDate).format(dateFormat).toString() : '';
            // pfiData.deliverySchedule = moment(pfiData.deliverySchedule).format(dateFormat).toString();
            if (buyerSameCheckBox) {
                const consigneeData = useStore.getState().consigneeData
                const businessPartnerId = form.getFieldValue('businessPartner');
                const indexConsignee = consigneeData.findIndex(eachConsigneeData => eachConsigneeData['_id'] === businessPartnerId);

                const currentConsigneeDetail = consigneeData[indexConsignee];
                pfiData.buyer.name = currentConsigneeDetail.name;
                pfiData.buyer.address = currentConsigneeDetail.address;
            }
            pfiData.pfiItemDetails.map(eachPfiData => {
                delete eachPfiData.hsCode;
            });
            delete pfiData.amountInWords;
            if (!PfiDetailsUpdateMutation.loading && !PfiDetailsMutation.loading) {
                if (proformaId) {
                    PfiDetailsUpdateMutation.callMutation({ variables: { companyId, pfiId: proformaId, input: pfiData } });
                } else {
                    PfiDetailsMutation.callMutation({ variables: { pfiInput: { ...pfiData, companyId } } })
                }
            }
        }
    };

    const onChangeBuyer = (e) => {
        setBuyerSameCheckBox(e.target.checked);
        const businessPartnerId = form.getFieldValue('businessPartner');
        if (businessPartnerId) {
            form.setFieldsValue({
                buyer: {
                    name: consigneeDetails.name,
                    address: consigneeDetails.address
                }
            });
            buyerName();
        } else {
            message.warn('Please select Consignee. On selecting consingee, Buyer will be updated.');
        }
    }

    const buyerName = () => {
        setBuyerName(form.getFieldValue('buyer').name);
    }

    const validate = () => {
        form.validateFields().then(data => {
            onFinish(form.getFieldsValue());
        }
        ).catch(error => {
            console.error(error, 'error')
        });
    }

    const addDescriptionDummyData = (index, field) => {
        const pfiDetailData = form.getFieldValue('pfiItemDetails');
        pfiDetailData[index] = pfiDetailData[index] || {};
        if (pfiDetailData[index].comments || pfiDetailData[index].comments === '') {
            pfiDetailData[index].comments = null;
        } else {
            pfiDetailData[index].comments = '';
        }
        pfiDetailDatas = pfiDetailData;
        form.setFieldsValue({
            pfiItemDetails: pfiDetailData
        });
    }

    // validateTrigger='onSubmit'
    return (
        <Form name="basic" form={form} onFinish={onFinish} validateMessages={validateNameMessages} initialValues={null} className="form document-form" scrollToFirstError={true}>
            <div className="document-layout__page document-edit-view">
                <h3 className="document-layout__title">
                    Proforma Invoice
                </h3>
                <div className="whole__document document-layout__content">
                    <div className="document-layout__section invoice__grid">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">Proforma Invoice No.</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="invoiceNumber" rules={[{ required: true, whitespace: true, message: "Proforma Invoice No. is missing" }]}>
                                    <Input autoComplete="off" className="document-edit-block__input " />
                                </Form.Item>
                            </div>
                        </div>
                    </div>

                    <div className="document-layout__section date__grid">
                        <div className="document-edit-block">
                            <label className="document-edit-block__label">PFI Date</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="date" rules={[{ required: true, message: "PFI Date is missing" }]}>
                                    {/* <Input autoComplete="off" className="document-edit-block__input " /> */}
                                    <DatePicker className="document-edit-block__input " format={dateFormat} placeholder={dateFormat} />
                                </Form.Item>
                            </div>
                        </div>
                    </div>

                    <div className="document-layout__section customer__po__number">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">Customer PO No.</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="customerPoNumber">
                                    <Input autoComplete="off" className="document-edit-block__input " />
                                </Form.Item>
                            </div>
                        </div>
                    </div>

                    <div className="document-layout__section customer__date__grid">
                        <div className="document-edit-block">
                            <label className="document-edit-block__label">Customer PO Date</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="customerPoDate" >
                                    {/* <Input autoComplete="off" className="document-edit-block__input " /> */}
                                    <DatePicker className="document-edit-block__input " format={dateFormat} placeholder={dateFormat} />
                                </Form.Item>
                            </div>
                        </div>
                    </div>

                    <div className="document-layout__section  consignee__grid ">
                        <div className="document-edit-block">
                            <label className="document-edit-block__label">Consignee</label>
                            <div className="document-edit-block__content">
                                {/* //rules={[{ required: true, whitespace: true, message: " is missing" }]} */}
                                <Form.Item name="businessPartner" rules={[{ required: true, whitespace: true, message: "Consignee is missing" }]}>
                                    <Select
                                        showSearch
                                        placeholder="Select Consignee"
                                        optionFilterProp="children"
                                        onChange={onChangeConsignee}
                                        // onFocus={onFocus}
                                        // onBlur={onBlur}
                                        // onSearch={onSearch}
                                        className="my-selector-class"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {tableRowdataConsignee.map((eachOption: any) => (
                                            renderOption(eachOption)
                                        ))
                                        }
                                    </Select>
                                </Form.Item>
                            </div>
                            <div className="document-edit-block__content">
                                <div className="document-edit-block__contact">
                                    <div className="document-edit-block__contact-info">
                                        <div>{consigneeDetails.name}</div>
                                        <div>{consigneeDetails.address}</div>
                                        <div>{consigneeDetails.country}</div>
                                        <div>{consigneeDetails.email}</div>
                                        <div>{consigneeDetails.phoneNumber}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section  buyer__grid">
                        <div className="document-edit-block">
                            <span className="document-edit-block__label">
                                <label>
                                    Buyer
                                </label>
                                <span style={{ float: "right" }}>
                                    <Checkbox onChange={onChangeBuyer}>
                                        Same As Consignee
                                    </Checkbox>
                                </span>
                            </span>
                            <div className="document-edit-block__content">
                                <label className="document-edit-block__label">Name</label>
                                <div className="document-edit-block__content">
                                    <Form.Item name={['buyer', 'name']} rules={[{ required: true, whitespace: true, message: "Buyer Name is missing" }]}>
                                        <Input autoComplete="off" className="document-edit-block__input " disabled={buyerSameCheckBox} onChange={buyerName} />
                                    </Form.Item>
                                </div>
                                <label className="document-edit-block__label">Address</label>
                                <div className="document-edit-block__content">
                                    <Form.Item name={['buyer', 'address']} >
                                        {/* rules={[{ required: true, whitespace: true, message: "Buyer Address is missing" }]} */}
                                        <Input className="document-edit-block__input " disabled={buyerSameCheckBox} />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="document-layout__section origin__country__grid__pfi">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">Origin Country</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="countryOfOrigin" rules={[{ required: true, whitespace: true, message: "Origin Country is missing" }]}>
                                    <Select
                                        showSearch
                                        placeholder="Origin of country"
                                        optionFilterProp="children"
                                        // onChange={onChange}
                                        // onFocus={onFocus}
                                        // onBlur={onBlur}
                                        // onSearch={onSearch}
                                        className="my-selector-class"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {tableRowdataCountries.map((eachOption: any) => (
                                            renderOption(eachOption)
                                        ))
                                        }
                                    </Select>
                                </Form.Item>
                            </div>

                        </div>
                    </div>
                    <div className="document-layout__section destination__country__grid__pfi">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">Destination Country </label>
                            <div className="document-edit-block__content">
                                <Form.Item name="countryOfDestination" rules={[{ required: true, whitespace: true, message: "Destination Country is missing" }]}>
                                    <Select
                                        showSearch
                                        placeholder="Destination of country"
                                        optionFilterProp="children"
                                        // onChange={onChange}
                                        // onFocus={onFocus}
                                        // onBlur={onBlur}
                                        // onSearch={onSearch}
                                        className="my-selector-class"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {tableRowdataCountries.map((eachOption: any) => (
                                            renderOption(eachOption)
                                        ))
                                        }
                                    </Select>
                                </Form.Item>
                            </div>

                        </div>
                    </div>
                    <div className="document-layout__section  method__dispatch__grid__pfi">
                        <div className="document-edit-block">
                            <label className="document-edit-block__label">Method of Dispatch</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="shippingMode" rules={[{ required: true, whitespace: true, message: "Method of Dispatch is missing" }]}>
                                    <Select
                                        showSearch
                                        placeholder="Select Method of Dispatch"
                                        optionFilterProp="children"
                                        // onChange={onChange}
                                        // onFocus={onFocus}
                                        // onBlur={onBlur}
                                        // onSearch={onSearch}
                                        className="my-selector-class"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {tableRowdataShippingModes.map((eachOption: any) => (
                                            renderOption(eachOption)
                                        ))
                                        }
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section vessel__grid__pfi">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">Vessel/Flight No</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="vesselNo" >
                                    {/* rules={[{ required: true, whitespace: true, message: "Vessel/Flight No is missing" }]} */}
                                    <Input autoComplete="off" className="document-edit-block__input " placeholder={'Vessel/Flight No'} />
                                </Form.Item>
                            </div>
                        </div>
                    </div>

                    <div className="document-layout__section port__loading__grid__pfi">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">Port of Loading</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="portOfLoading" rules={[{ required: true, whitespace: true, message: "Port of Loading is missing" }]}>
                                    <Select
                                        showSearch
                                        placeholder="Select Port of Loading"
                                        optionFilterProp="children"
                                        // onChange={onChange}
                                        // onFocus={onFocus}
                                        // onBlur={onBlur}
                                        // onSearch={onSearch}
                                        className="my-selector-class"
                                        filterOption={(input, option) =>
                                            option.children[0].toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {PortsQuery.data?.getAllPorts.map((eachOption: any) => (
                                            renderOptionPort(eachOption)
                                        ))
                                        }
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section port__destination__grid__pfi">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">Port of Destination</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="portOfDestination" rules={[{ required: true, whitespace: true, message: "Port of Destination is missing" }]}>
                                    <Select
                                        showSearch
                                        placeholder="Select Port of Destination"
                                        optionFilterProp="children"
                                        // onChange={onChange}
                                        // onFocus={onFocus}
                                        // onBlur={onBlur}
                                        // onSearch={onSearch}
                                        className="my-selector-class"
                                        filterOption={(input, option) =>
                                            option.children[0].toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {PortsQuery.data?.getAllPorts.map((eachOption: any) => (
                                            renderOptionPort(eachOption)
                                        ))
                                        }
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                    </div>

                    <div className="document-layout__section pfidelivery__term__grid">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">Delivery Terms</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="deliveryTerms" rules={[{ required: true, whitespace: true, message: "Delivery Terms is missing" }]}>
                                    <Select
                                        showSearch
                                        placeholder="Select Delivery Terms"
                                        optionFilterProp="children"
                                        onChange={onChangeDeliveryTerms}
                                        // onFocus={onFocus}
                                        // onBlur={onBlur}
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {tableRowdataDelivery.map((eachOption: any) => (
                                            renderOption(eachOption)
                                        ))
                                        }
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section port__discharge__grid">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">Currency</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="currency" rules={[{ required: true, whitespace: true, message: "Currency is missing" }]}>
                                    <Select
                                        showSearch
                                        placeholder="Select Currency"
                                        optionFilterProp="children"
                                        onChange={onChangeCurrency}
                                        // onFocus={onFocus}
                                        // onBlur={onBlur}
                                        // onSearch={onSearch}
                                        className="my-selector-class"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {currencyData.map((eachOption: any) => (
                                            renderOption(eachOption)
                                        ))
                                        }
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                    </div>


                    <div className="document-layout__section delivery__schedule__grid__pfi">
                        <div className="document-edit-block">
                            <label className="document-edit-block__label">Scheduled Delivery</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="deliverySchedule" rules={[{ required: true, whitespace: true, message: "Scheduled Delivery is missing" }]}>
                                    {/* <Input autoComplete="off" className="document-edit-block__input " /> */}
                                    {/* <DatePicker className="document-edit-block__input " format={dateFormat} placeholder={dateFormat} /> */}
                                    <Input autoComplete="off" className="document-edit-block__input " placeholder={'Scheduled Delivery'} />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section validity__grid__pfi">
                        <div className="document-edit-block">
                            <label className="document-edit-block__label">Final Destination</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="finalDestination">
                                    <Select
                                        showSearch
                                        placeholder="Final Destination of country"
                                        optionFilterProp="children"
                                        // onChange={onChange}
                                        // onFocus={onFocus}
                                        // onBlur={onBlur}
                                        // onSearch={onSearch}
                                        className="my-selector-class"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {tableRowdataCountries.map((eachOption: any) => (
                                            renderOption(eachOption)
                                        ))
                                        }
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                    </div>


                    <div className="document-layout__section payment__term_grid">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">Payment Terms</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="paymentTerms" rules={[{ required: true, whitespace: true, message: "Payment Terms is missing" }]}>
                                    <Select
                                        showSearch
                                        placeholder="Select Payment Terms"
                                        optionFilterProp="children"
                                        // onChange={onChange}
                                        // onFocus={onFocus}
                                        // onBlur={onBlur}
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {tableRowdataPaymentTerms.map((eachOption: any) => (
                                            renderOption(eachOption)
                                        ))
                                        }
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section product__table__grid">
                        <div className="document-edit-block__table">
                            <div className="document-edit-block__table-header">
                                <div className="document-edit-block__table-header-cell min_max_width_13">
                                    HS Code
                                </div>
                                <div className="document-edit-block__table-header-cell min_max_width_22">
                                    Description of Goods
                                </div>
                                <div className="document-edit-block__table-header-cell min_max_width_15">
                                    Packing Type
                                </div>
                                <div className="document-edit-block__table-header-cell min_max_width_125">
                                    Quantity
                                </div>
                                <div className="document-edit-block__table-header-cell min_max_width_125">
                                    No Of Packages
                                </div>
                                <div className="document-edit-block__table-header-cell min_max_width_833">
                                    Unit Type
                                </div>
                                <div className="document-edit-block__table-header-cell min_max_width_833">
                                    Price({selectedCurrency})
                                </div>
                                <div className="document-edit-block__table-header-cell min_max_width_833">
                                    Amount({selectedCurrency})
                                </div>
                            </div>
                        </div>
                        <Form.List name="pfiItemDetails">
                            {(fields, { add, remove }) => {
                                return (
                                    <div>
                                        {fields.map((field, index) => (
                                            <div style={{ width: '100%' }}>
                                                <Form.Item
                                                    required={false}
                                                    key={index}>
                                                    {fields.length > 1 ? (
                                                        <div className={`document-edit-block__table-content-row-actions1 document-edit-block__table-content-row-actions--left  right__105 ${(pfiDetailDatas[index]?.comments || pfiDetailDatas[index]?.comments === '') ? `description__top` : `no__description__top`}`}>
                                                            <DeleteTwoTone
                                                                className="document-edit-block__table-content-row-action "
                                                                onClick={() => {
                                                                    remove(field.name);
                                                                    onNoPackageChange(-1);
                                                                }} />
                                                        </div>
                                                    ) : null}
                                                    <div className={`document-edit-block__table-content-row-actions1 document-edit-block__table-content-row-actions--left ${(pfiDetailDatas[index]?.comments || pfiDetailDatas[index]?.comments === '') ? `description__top` : `no__description__top`}`}>
                                                        <FolderAddTwoTone className="document-edit-block__table-content-row-action "
                                                            onClick={() => {
                                                                addDescriptionDummyData(index, field);
                                                            }} />
                                                    </div>
                                                    <Space style={{ marginBottom: 8 }} align="start">
                                                        <div className="document-edit-block__table-content">
                                                            <div className="document-edit-block__table-content-row document-edit-block__table-content-row--draggable">
                                                                <div className="document-edit-block__table-content-cell min_max_width_13 text__align__left">
                                                                    <Form.Item
                                                                        {...field}
                                                                        name={[field.name, 'hsCode']}
                                                                        fieldKey={[field.fieldKey, 'hsCode']}
                                                                        rules={[{ required: true, whitespace: true, message: "HS Code is missing" }]}
                                                                    >
                                                                        {/* onChange={(event) => onNoPackageChange(index)} */}
                                                                        <Select
                                                                            showSearch
                                                                            placeholder="Hs Code"
                                                                            optionFilterProp="children"
                                                                            onChange={(event) => onChangeHsCode(index)}
                                                                            // onFocus={onFocus}
                                                                            // onBlur={onBlur}
                                                                            // onSearch={onSearch}
                                                                            className="my-selector-class"
                                                                            filterOption={(input, option) =>
                                                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                            }
                                                                        >
                                                                            {tableRowdataProducthsCode.map((eachOption: any) => (
                                                                                renderOption(eachOption)
                                                                            ))
                                                                            }
                                                                        </Select>
                                                                    </Form.Item>
                                                                </div>
                                                                <div className="document-edit-block__table-content-cell min_max_width_22 text__align__left">
                                                                    <Form.Item
                                                                        {...field}
                                                                        name={[field.name, 'descriptionOfGoods']}
                                                                        fieldKey={[field.fieldKey, 'descriptionOfGoods']}
                                                                        rules={[{ required: true, whitespace: true, message: "Description Of Goods is missing" }]}
                                                                    >
                                                                        {/* tableRowdataProductName */}
                                                                        <Select
                                                                            showSearch
                                                                            placeholder="Description of Goods"
                                                                            optionFilterProp="children"
                                                                            onChange={(event) => onChangeProductName(index)}
                                                                            // onFocus={onFocus}
                                                                            // onBlur={onBlur}
                                                                            // onSearch={onSearch}
                                                                            className="my-selector-class"
                                                                            filterOption={(input, option) =>
                                                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                            }
                                                                        >
                                                                            {tableRowdataProductName.map((eachOption: any) => (
                                                                                renderOption(eachOption)
                                                                            ))
                                                                            }
                                                                        </Select>
                                                                    </Form.Item>
                                                                </div>
                                                                <div className="document-edit-block__table-content-cell min_max_width_15 text__align__left">
                                                                    <Form.Item
                                                                        {...field}
                                                                        name={[field.name, 'packingTypes']}
                                                                        fieldKey={[field.fieldKey, 'packingTypes']}
                                                                        rules={[{ required: true, whitespace: true, message: "Packing Type is missing" }]}
                                                                        className=""
                                                                    >
                                                                        <Select
                                                                            showSearch
                                                                            placeholder="Packing Type"
                                                                            optionFilterProp="children"
                                                                            // onFocus={onFocus}
                                                                            // onBlur={onBlur}
                                                                            // onSearch={onSearch}
                                                                            className="my-selector-class dropdown__ellipsis"
                                                                            filterOption={(input, option) =>
                                                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                            }
                                                                        >
                                                                            {tableRowdataPackingTypes.map((eachOption: any) => (
                                                                                renderOption(eachOption)
                                                                            ))
                                                                            }
                                                                        </Select>
                                                                    </Form.Item>
                                                                </div>
                                                                <div className="document-edit-block__table-content-cell min_max_width_125 text__align__right">
                                                                    <Form.Item
                                                                        {...field}
                                                                        name={[field.name, 'quantity']}
                                                                        fieldKey={[field.fieldKey, 'quantity']}
                                                                        rules={[{ required: true, message: "Quantity is missing" }]}
                                                                    >
                                                                        <InputNumber autoComplete="off" className="document-edit-block__input document-edit-block__input__number" onChange={(event) => onNoPackageChange(index)} />
                                                                    </Form.Item>
                                                                </div>
                                                                <div className="document-edit-block__table-content-cell min_max_width_125 text__align__right">
                                                                    <Form.Item
                                                                        {...field}
                                                                        name={[field.name, 'noOfPackages']}
                                                                        fieldKey={[field.fieldKey, 'noOfPackages']}
                                                                        rules={[{ required: true, message: "No Of Packages is missing" }]}
                                                                    >
                                                                        <InputNumber autoComplete="off" className="document-edit-block__input document-edit-block__input__number" />
                                                                    </Form.Item>
                                                                </div>
                                                                <div className="document-edit-block__table-content-cell min_max_width_833 text__align__left">

                                                                    <Form.Item
                                                                        {...field}
                                                                        name={[field.name, 'unitType']}
                                                                        fieldKey={[field.fieldKey, 'unitType']}
                                                                        rules={[{ required: true, whitespace: true, message: "Unit Type is missing" }]}
                                                                    >
                                                                        <Input autoComplete="off" className="document-edit-block__input document-edit-block__input__number" />
                                                                    </Form.Item>
                                                                </div>
                                                                <div className="document-edit-block__table-content-cell min_max_width_833 text__align__right">
                                                                    <Form.Item
                                                                        {...field}
                                                                        name={[field.name, 'rate']}
                                                                        fieldKey={[field.fieldKey, 'rate']}
                                                                        rules={[{ required: true, message: "Price is missing" }]}
                                                                    >
                                                                        <InputNumber autoComplete="off" className="document-edit-block__input document-edit-block__input__number" onChange={(event) => onPriceChange(index)} />
                                                                    </Form.Item>
                                                                </div>
                                                                <div className="document-edit-block__table-content-cell min_max_width_833 text__align__right">
                                                                    <div className="dtotal__amount__div" >
                                                                        <Form.Item
                                                                            {...field}
                                                                            name={[field.name, 'amount']}
                                                                            fieldKey={[field.fieldKey, 'amount']}
                                                                        >
                                                                            <Input autoComplete="off" className="document-edit-block__input " readOnly />
                                                                        </Form.Item>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Space>
                                                    {(pfiDetailDatas[index]?.comments || pfiDetailDatas[index]?.comments === '') ? (<Space style={{ marginBottom: 8, marginLeft: '12.9%', width: '22%' }} align="start">
                                                        <div className="document-edit-block__table-content">
                                                            <div className="document-edit-block__table-content-row document-edit-block__table-content-row--draggable">
                                                                <div className="document-edit-block__table-content-cell text__align__left">
                                                                    <Form.Item
                                                                        {...field}
                                                                        name={[field.name, 'comments']}
                                                                        fieldKey={[field.fieldKey, 'comments']}
                                                                        rules={[{ required: true, whitespace: true, message: 'Description is missing' }]}
                                                                    >
                                                                        <Input autoComplete="off" className="document-edit-block__input document-edit-block__input__number" />
                                                                    </Form.Item>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Space>) : null}
                                                </Form.Item>
                                            </div>
                                        ))}
                                        <div className="flex">
                                            <div className="document-edit-block__table-button">
                                                <Button type="primary" ghost onClick={() => { add(); }}>
                                                    Add Line
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                );
                            }}
                        </Form.List>
                    </div>
                    {/* Consignment Total Quantity */}
                    <div className="document-layout__section consignment__total__quantity__label__grid pdf__label">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label label__margin__top">Consignment Total Quantity</label>
                        </div>
                    </div>
                    <div className="document-layout__section consignment__total__quantity__number__grid">
                        <div className="document-edit-block" >
                            <div className="document-edit-block__content">
                                <Form.Item name="totalQuantity" rules={[{ required: true, message: "Consignment Total Quantity is missing" }]}>
                                    <Input autoComplete="off" className="document-edit-block__input " readOnly />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section total__amount__label__grid pdf__label">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label label__margin__top">Amount Total({selectedCurrency})</label>
                        </div>
                    </div>
                    <div className="document-layout__section total__amount__number__grid">
                        <div className="document-edit-block" >
                            <div className="document-edit-block__content">
                                <Form.Item name="totalAmount" rules={[{ required: true, message: "Amount Total is missing" }]}>
                                    <Input autoComplete="off" className="document-edit-block__input " readOnly />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section amount__words__label__grid pdf__label">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label label__margin__top">Amount in Words</label>
                        </div>
                    </div>
                    <div className="document-layout__section amount__words__number__grid">
                        <div className="document-edit-block" >
                            <div className="document-edit-block__content">
                                <Form.Item name="amountInWords" rules={[{ required: true,  message: "Amount in Words is missing" }]}>
                                    <Input autoComplete="off" className="document-edit-block__input " readOnly />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section bank__detail__grid">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">Bank Details</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="bankDetails" rules={[{ required: true, whitespace: true, message: "Bank Details is missing" }]}>
                                    <Select
                                        showSearch
                                        placeholder="Select Bank Details"
                                        optionFilterProp="children"
                                        onChange={onChangeBankDetails}
                                        // onFocus={onFocus}
                                        // onBlur={onBlur}
                                        // onSearch={onSearch}
                                        className="my-selector-class"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {tableRowDataCompanyBank.map((eachOption: any) => (
                                            renderOption(eachOption)
                                        ))
                                        }
                                    </Select>
                                    {/* <Input.TextArea className="document-edit-block__input " /> */}
                                </Form.Item>
                            </div>
                            <div className="document-edit-block__content">
                                <div className="document-edit-block__contact">
                                    <div className="document-edit-block__contact-info">
                                        <Row gutter={24}><Col span={6}><b>Account Name:</b></Col><Col span={6}>{bankDetails.accountName}</Col></Row>
                                        <Row gutter={24}><Col span={6}><b>Account No:</b></Col><Col span={6}>{bankDetails.acNumber}</Col></Row>
                                        <Row gutter={24}><Col span={6}><b>Bank Name:</b></Col><Col span={6}>{bankDetails.bankName}</Col></Row>
                                        <Row gutter={24}><Col span={6}><b>Address:</b></Col><Col span={6}>{bankDetails.address}</Col></Row>
                                        <Row gutter={24}><Col span={6}><b>Swift Code:</b></Col><Col span={6}>{bankDetails.swiftCode}</Col></Row>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section fob__cfr__heading__grid">
                        <div className="document-edit-block text__align__center" >
                            <label className="document-edit-block__label label__margin__top">FOB/CFR/CIF Break up</label>
                        </div>
                    </div>

                    <div className="document-layout__section cfr__price__label__grid pdf__label">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label label__margin__top">{selectedDeliveryTerms} Price({selectedCurrency})</label>
                        </div>
                    </div>
                    <div className="document-layout__section cfr__price__number__grid">
                        <div className="document-edit-block" >
                            <div className="document-edit-block__content">
                                <Form.Item name={['breakUpAmount', 'cfbPrice']} rules={[{ required: true, message: "CFR Price is missing" }]}>
                                    <InputNumber autoComplete="off" className="document-edit-block__input document-edit-block__input__number" onChange={totalFobPriceFunc} readOnly />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section less__freight__label__grid pdf__label">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label label__margin__top">Less Freight({selectedCurrency})</label>
                        </div>
                    </div>
                    <div className="document-layout__section less__freight__number__grid">
                        <div className="document-edit-block" >
                            <div className="document-edit-block__content">
                                <Form.Item name={['breakUpAmount', 'lessFreight']} rules={[{ required: true, message: "Less Freight is missing" }]}>
                                    <InputNumber autoComplete="off" className="document-edit-block__input document-edit-block__input__number" onChange={totalFobPriceFunc} />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section less__insurance__label__grid pdf__label">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label label__margin__top">Less Insurance({selectedCurrency})</label>
                        </div>
                    </div>
                    <div className="document-layout__section less__insurance__number__grid">
                        <div className="document-edit-block" >
                            <div className="document-edit-block__content">
                                <Form.Item name={['breakUpAmount', 'lessInsurance']} rules={[{ required: true, message: "Less Insurance is missing" }]}>
                                    <InputNumber autoComplete="off" className="document-edit-block__input document-edit-block__input__number" onChange={totalFobPriceFunc} />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section total__fob__label__grid pdf__label">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label label__margin__top">Total FOB Price({selectedCurrency})</label>
                        </div>
                    </div>
                    <div className="document-layout__section total__fob__number__grid">
                        <div className="document-edit-block" >
                            <div className="document-edit-block__content">
                                <Form.Item name={['breakUpAmount', 'totalFobPrice']} rules={[{ required: true, message: "Total FOB Price is missing" }]}>
                                    <Input autoComplete="off" className="document-edit-block__input " readOnly />
                                </Form.Item>
                                {minTotalPriceError && <div className="ant-form-error"><div>Total FOB Price must be greater than 0</div></div>}
                            </div>
                        </div>
                    </div>

                    <div className="document-layout__section pfiterms__condition__grid">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">Terms &amp; Conditions</label>
                            <div className="document-edit-block__content">
                                <Form.Item name="termsAndConditions" >
                                {/* rules={[{ required: true, message: "Terms & Conditions is missing" }]} */}
                                    <Input.TextArea className="document-edit-block__input " />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section buyer__sign__label__grid">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">For, {buyerNameConst}</label>
                        </div>
                    </div>
                    <div className="document-layout__section seller__sign__label__grid pdf__label">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">For, Chemtrade</label>
                        </div>
                    </div>
                    <div className="document-layout__section khaali__space__grid">
                        <div className="document-edit-block" >
                            <div className="document-edit-block__content">
                            </div>
                        </div>
                    </div>
                    <div className="document-layout__section buyer__name__sign__label__grid">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">Authorized Signature/Name</label>
                        </div>
                    </div>
                    <div className="document-layout__section seller__name__sign__label__grid pdf__label">
                        <div className="document-edit-block" >
                            <label className="document-edit-block__label">Authorized Signature/Name</label>
                        </div>
                    </div>
                </div>
                <Form.Item style={{ marginTop: '15px' }}>
                    <Button type="primary" htmlType="submit" className="btn" ghost style={{ width: 75 }}>
                        {(PfiDetailsUpdateMutation.loading || PfiDetailsMutation.loading) ? <LoadingOutlined style={{ fontSize: '20px' }} /> : 'Submit'}
                    </Button>
                    <Button danger onClick={redirectBack} type="ghost">
                        Cancel
                    </Button>
                </Form.Item>
            </div>
        </Form>
    );
}
export default AddEditProforma
